import { Type } from '@angular/core';
import { BaseDialog } from './dialog-base.component';
import { DialogConfig } from './dialog.interface';

export class DialogInstance {
    constructor(
        public component: Type<BaseDialog>,
        public data: unknown,
        public config: DialogConfig
    ) {}
}
